import React from 'react'
import Header from './Common/Header/Header'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './Home/Home'

const App = () => {
  return (

    <BrowserRouter>
    <Header/>
    <Routes>

    <Route path='/' element={<Home/>} />
    
    </Routes>
    </BrowserRouter>
   
  )
}

export default App